import { createContext } from "react";
import { ThemeProps } from "../models/theme";
import { PLACEHOLDER_THEME_ID } from "../constants";
import {
  FALLBACK_PRIMARY,
  FALLBACK_SECONDARY,
  FALLBACK_TERTIARY,
} from "../config/theme";

export interface ThemeContextInterface {
  theme: ThemeProps;
  clearData: () => void;
  updateTheme: (data: ThemeProps) => void;
}

// The portal's own identity, not a tenant's, and it resolves with zero API
// calls: the branding shell has to stand before any theme request returns and
// survive one that never does. LANDING is the scope a page has before a
// corporate is known.
export const DEFAULT_THEME: ThemeProps = {
  id: PLACEHOLDER_THEME_ID,
  url: "",
  url_type: "LANDING",
  color_primary: FALLBACK_PRIMARY,
  color_secondary: FALLBACK_SECONDARY,
  color_tertiary: FALLBACK_TERTIARY,
  light_gray: "#FCFCFC",
  logo_for_payment_portal: "",
  is_active: true,
};

export const themeContextDefaults: ThemeContextInterface = {
  theme: DEFAULT_THEME,
  clearData: () => {
    //function to clear Data
  },
  updateTheme: () => {
    //function to clear Data
  },
};

export const ThemeContext =
  createContext<ThemeContextInterface>(themeContextDefaults);
